import _ from 'lodash'
import type { Ref } from '@wix/materializer'
import { Component, pointers, SlotsDataItem } from '@wix/thunderbolt-becky-types'
import { createRefInResolvedRefsNamespaces } from '../../../byRefUtils'
import {
	GHOST_REF_COMP_STRUCTURE_OVERRIDES,
	INVALIDATE_STRUCTURE,
	KEEP_GHOST_COMPONENTS_REF,
	RESOLVED_REF_IS_GHOST_COMPONENT_ASPECT,
	STRUCTURE_ASPECT,
} from '../../../constants'
import { createByRefsisCompNode } from '../../../compNodeUtils'
import type { isGhostCompToViewItem } from './isGhostComponent'

const {
	data: {
		DATA_MAPS: { SLOTS },
	},
	components: {
		PROPERTY_TYPES: { SLOTS_QUERY },
	},
} = pointers

type StructureDeps = {
	templateComp: Ref<Component>
	slotsDataItem: Ref<SlotsDataItem>
	ghostComponent: Ref<isGhostCompToViewItem>
	keepGhostComponents: Ref<boolean>
	_invalidateStructureRef: Ref<boolean>
}

export const structure = createByRefsisCompNode<StructureDeps, Component | undefined>({
	getDependencies: (templateCompId, { id }, scopedCreateRef) => ({
		templateComp: scopedCreateRef<Component>(STRUCTURE_ASPECT, templateCompId),
		slotsDataItem: createRefInResolvedRefsNamespaces<SlotsDataItem>(SLOTS, `${id}-${SLOTS_QUERY}`),
		ghostComponent: createRefInResolvedRefsNamespaces<isGhostCompToViewItem>(
			RESOLVED_REF_IS_GHOST_COMPONENT_ASPECT,
			id
		),
		keepGhostComponents: KEEP_GHOST_COMPONENTS_REF,
		_invalidateStructureRef: createRefInResolvedRefsNamespaces<boolean>(INVALIDATE_STRUCTURE, id),
	}),
	toViewItem: (
		inflatedStructure,
		{ templateComp, slotsDataItem, ghostComponent, keepGhostComponents, _invalidateStructureRef }
	) => {
		if (!templateComp) {
			return
		}

		if (ghostComponent?.isGhostComp && !keepGhostComponents) {
			return {
				...inflatedStructure,
				...GHOST_REF_COMP_STRUCTURE_OVERRIDES,
			}
		}

		if (slotsDataItem && !_.isEmpty(slotsDataItem.slots)) {
			return {
				...inflatedStructure,
				slots: slotsDataItem.slots,
			}
		}

		return inflatedStructure
	},
})
